import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import welcomeCallService from "./SendWelcomePackageService";
import { toast } from "react-toastify";
const initialState = {
  sendWelcomPackage: false,
  isError: false,
  isSuccess: false,
  isLodaing: false,
  massage: "",
};

export const sendWelcomePackage = createAsyncThunk(
  "SendWelcomePackage/post",
  async (data, thunkAPI) => {
    try {
      return await welcomeCallService.sendWelcomePackageAction(data);
    } catch (error) {
      const massage =
        (error.response &&
          error.response.data &&
          error.response.data.massage) ||
        error.response.data.error ||
        error.message ||
        error.toString();
      error?.response?.data?.errors?.map((err) =>
        toast.error(err.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
      );
      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const sendWelcomePackageSlice = createSlice({
  name: "sendWelcomePackage",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLodaing = false;
      state.massage = "";
    },
  },
  extraReducers: {
    //send welcome package
    [sendWelcomePackage.pending]: (state) => {
      state.isLodaing = true;
    },
    [sendWelcomePackage.fulfilled]: (state, { payload }) => {
      state.isLodaing = false;
      state.isSuccess = true;
      state.sendWelcomPackage = payload;
    },
    [sendWelcomePackage.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.massage = action.payload;
    },
  },
});

export const { reset } = sendWelcomePackageSlice.actions;
export default sendWelcomePackageSlice.reducer;
